// import Q from 'q'
export enum GATT_ENUM {
  NOTIFICATIONS = "gatt/notifications",
  WRITE="gatt/write"
}
interface IGATTRequestParams {
  
    device: string;
    serviceUUID?: "FFE0"|string,
    characteristicUUID?: "FFE1"|string,
    value?: "41"|string,
  
}
interface IGATTRequest {
  command:GATT_ENUM;
  parameters?: IGATTRequestParams;
}
export interface IGATT_RESPONSE {
  id: any;
  lastUpdated:Date;
  timestamp:Date;
  userId:number;
}

// class PromiseDefer {
//     resolve: (value: unknown) => void;
//     reject: (reason?: any) => void;
//     then: <TResult1 = unknown, TResult2 = never>(onfulfilled?: (value: unknown) => TResult1 | PromiseLike<TResult1>, onrejected?: (reason: any) => TResult2 | PromiseLike<TResult2>) => Promise<TResult1 | TResult2>;
//     constructor() {
//         var prom=new Promise((resolve,reject)=>{
//             this.resolve=resolve;
//             this.reject=reject;
//         });
//         this.then=prom.then;
//         prom.then.bind(this);
//         prom.catch.bind(this);
//         prom.finally
//     }
//     // then(fn:(...args:any)=>PromiseLike<any>) {
//     //     return 
//     // }

// }
export class GATTCommand {
  // dataInputLogin: { login: string; password: string; }=null;

  /**
   * this as same as "USERNAME"
   */
  deviceId: string;
  /**
   * this also called "deviceid" 
   */
  private usernamelogin: string;

  constructor(usernamelogin: string) {
    this.setAuth(usernamelogin);
  }
  private setAuth(usernamelogin: string) {
    //     const loginDevice = sessionStorage.getItem("LOGINDEVICE");
    //   const passwordDevice = sessionStorage.getItem("PASSWORDDEVICE");
    // const deviceId = sessionStorage.getItem("USERNAME");
    this.deviceId = usernamelogin;
    this.usernamelogin = usernamelogin;
    // this.dataInputLogin = {
    //   login: loginDevice||sessionStorage.getItem("LOGINDEVICE"),
    //   password: passwordDevice||sessionStorage.getItem("PASSWORDDEVICE"),
    // };
  }

  /**
   * digitaltwins-service#609: the command goes through the twin server, which holds the
   * device service login and always addresses the signed-in user's own device. The page
   * no longer reads the shared `leanbot_token` credential or logs in to lbadmin itself.
   */
  async executeCommand(cmd: IGATTRequest): Promise<IGATT_RESPONSE> {
    const body = {
      command: cmd.command,
      parameters: Object.assign({
        serviceUUID: "FFE0",
        characteristicUUID: "FFE1",
        value: "41",
      }, cmd.parameters || {}),
    };
    return await fetch("/leanbot-device/command", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).then((res) => res.json());
  }
  async queryGATTStatus(data: IGATT_RESPONSE) {
    return await fetch("/leanbot-device/command/" + encodeURIComponent(String(data.id)), {
      method: "GET",
      credentials: "same-origin",
    }).then((resp) => resp.json());
  }

}
